export interface ConsentWordingItem {
    fieldName:
        | 'privacyPolicyConsent'
        | 'informationAccurate'
        | 'understandsClaim'
        | 'understandsFees'
        | 'actingFreely'
        | 'sentinelOnlyFirm'
    label: string
    emphasisedText: string
}

export const consentWordingV3: ConsentWordingItem[] = [
    {
        fieldName: 'privacyPolicyConsent',
        label: 'I confirm that I have read and agree to the ViewThru consent information above.',
        emphasisedText: 'I confirm that I have read and agree to the ViewThru consent information above.',
    },
    {
        fieldName: 'informationAccurate',
        label: 'My information is true and accurate. I confirm the details I have provided are correct and that I am the account holder, or am authorised to act, on the finance agreement(s) being claimed.',
        emphasisedText: 'My information is true and accurate.',
    },
    {
        fieldName: 'understandsClaim',
        label: 'I understand what I am claiming for. I am making a claim for mis sold car finance, and I know I do not need to use a law firm to do this. I can complain to my lender directly for free, and the Financial Ombudsman Service may be able to help me.',
        emphasisedText: 'I understand what I am claiming for.',
    },
    {
        fieldName: 'understandsFees',
        label: "I understand the fees. I have read and understood how Sentinel Legal's fees work, including the percentage, the maximum charge, VAT, and my 14 day right to cancel without charge.",
        emphasisedText: 'I understand the fees.',
    },
    {
        fieldName: 'actingFreely',
        label: 'I am acting freely. I do not feel pressured or rushed into signing this agreement, and I have had the chance to ask questions and take independent advice before proceeding.',
        emphasisedText: 'I am acting freely.',
    },
    {
        fieldName: 'sentinelOnlyFirm',
        label: 'Sentinel Legal is my only firm. I confirm that Sentinel Legal is the only firm instructed to handle my claim. Any instruction previously given to any other law firm or claims management company is terminated with immediate effect and has no continuing effect, and I authorise Sentinel Legal to notify them and my lender(s) of this.',
        emphasisedText: 'Sentinel Legal is my only firm.',
    },
]

export const CURRENT_CONSENT_WORDING_VERSION = '3'

const motorFinanceSignatureTypes = new Set([
    'foa-signature',
    'foa-v2-signature',
    'foa-v2-additional-signature',
    'foa-v2-additional-signature-resign',
    'poc-signature',
    'poc-v3-signature',
    'EX160-signature',
    'Part36-signature',
    'notPart36-signature',
    'sentinel-cfa-signature',
    'fos-cfa-signature',
    'fos-cfa-signature-oa',
    'fos-cfa-signature-opop',
    'litigation-cfa-signature',
    'lc-cfa-signature',
    'so-cfa-signature',
    'dsar-loa',
    'dsar-loa-dob-conf',
    'sd-cfa-signature',
    'allegiant-cfa-signature',
    'gorilla-cfa-signature',
    'loa-options',
    'oa-retransfer-cfa-signature',
    'cfa-referral-signature',
])

export const usesMotorFinanceConsentV3 = (signatureType: unknown) =>
    typeof signatureType === 'string' && motorFinanceSignatureTypes.has(signatureType)
